import { useCallback, useEffect, useMemo, useState, type ReactNode } from 'react';

import { usePlatform } from '@/platform/usePlatform';

import { ThemeContext } from './ThemeContext';
import { applyTheme, readThemeChoice, writeThemeChoice, type ThemeChoice } from './theme-store';

/**
 * Тема приложения — выбор человека, не хоста (CLAUDE.md, «Интерфейс»).
 *
 * Атрибут на <html> к первому кадру уже поставил public/theme-init.js;
 * здесь — состояние для переключателя, сохранение и цвет хрома хоста.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  const platform = usePlatform();
  const [theme, setThemeState] = useState<ThemeChoice>(readThemeChoice);

  useEffect(() => {
    applyTheme(theme, platform);
  }, [theme, platform]);

  const setTheme = useCallback((choice: ThemeChoice) => {
    writeThemeChoice(choice);
    setThemeState(choice);
  }, []);

  const value = useMemo(() => ({ theme, setTheme }), [theme, setTheme]);

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}
